import React from "react";

function DragOver(props) {
  return null;
  //return <div className="pagebuilder-drag-over" />;
}

export default DragOver;
